/** Buyers may order from anywhere we can legally trade. Flowers only travel inside Morocco. */
const ALL = "AD AE AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BE BF BG BH BJ BL BM BN BO BQ BR BS BT BW BZ CA CH CI CK CL CM CO CR CV CW CY CZ DE DK DM DO DZ EC EE EG ES FI FJ FK FM FO FR GA GB GD GE GF GG GI GL GM GP GQ GR GT GU GY HK HN HR HU IE IL IM IN IS IT JE JM JO JP KE KG KH KI KM KN KR KW KY KZ LA LC LI LK LS LT LU LV MA MC MD ME MF MG MH MK MN MO MP MQ MS MT MU MV MW MX MY MZ NA NC NE NF NG NL NO NP NR NU NZ OM PA PE PF PG PH PL PR PS PT PW PY QA RE RO RS RW SA SC SE SG SI SK SM SN SR ST SV SX SZ TC TD TG TH TL TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VG VI VN VU WF WS ZA ZM".split(" ");

/** Sanctioned, embargoed or blocked for card fraud — never offered at checkout. */
export const BLOCKED = "AF BY BI CD CF CU ER ET GN GW HT IQ IR KP LB LR LY ML MM NI PK RU SD SO SS SY TJ TM UA_CRIMEA VE YE ZW".split(" ");

/** ISO-3166 alpha-2 → international dialling code. */
export const DIAL = {
  AD: "+376", AE: "+971", AG: "+1268", AI: "+1264", AL: "+355", AM: "+374", AO: "+244", AR: "+54",
  AS: "+1684", AT: "+43", AU: "+61", AW: "+297", AX: "+358", AZ: "+994", BA: "+387", BB: "+1246",
  BE: "+32", BF: "+226", BG: "+359", BH: "+973", BJ: "+229", BL: "+590", BM: "+1441", BN: "+673",
  BO: "+591", BQ: "+599", BR: "+55", BS: "+1242", BT: "+975", BW: "+267", BZ: "+501", CA: "+1",
  CH: "+41", CI: "+225", CK: "+682", CL: "+56", CM: "+237", CO: "+57", CR: "+506", CV: "+238",
  CW: "+599", CY: "+357", CZ: "+420", DE: "+49", DK: "+45", DM: "+1767", DO: "+1809", DZ: "+213",
  EC: "+593", EE: "+372", EG: "+20", ES: "+34", FI: "+358", FJ: "+679", FK: "+500", FM: "+691",
  FO: "+298", FR: "+33", GA: "+241", GB: "+44", GD: "+1473", GE: "+995", GF: "+594", GG: "+44",
  GI: "+350", GL: "+299", GM: "+220", GP: "+590", GQ: "+240", GR: "+30", GT: "+502", GU: "+1671",
  GY: "+592", HK: "+852", HN: "+504", HR: "+385", HU: "+36", IE: "+353", IL: "+972", IM: "+44",
  IN: "+91", IS: "+354", IT: "+39", JE: "+44", JM: "+1876", JO: "+962", JP: "+81", KE: "+254",
  KG: "+996", KH: "+855", KI: "+686", KM: "+269", KN: "+1869", KR: "+82", KW: "+965", KY: "+1345",
  KZ: "+7", LA: "+856", LC: "+1758", LI: "+423", LK: "+94", LS: "+266", LT: "+370", LU: "+352",
  LV: "+371", MA: "+212", MC: "+377", MD: "+373", ME: "+382", MF: "+590", MG: "+261", MH: "+692",
  MK: "+389", MN: "+976", MO: "+853", MP: "+1670", MQ: "+596", MS: "+1664", MT: "+356", MU: "+230",
  MV: "+960", MW: "+265", MX: "+52", MY: "+60", MZ: "+258", NA: "+264", NC: "+687", NE: "+227",
  NF: "+672", NG: "+234", NL: "+31", NO: "+47", NP: "+977", NR: "+674", NU: "+683", NZ: "+64",
  OM: "+968", PA: "+507", PE: "+51", PF: "+689", PG: "+675", PH: "+63", PL: "+48", PR: "+1787",
  PS: "+970", PT: "+351", PW: "+680", PY: "+595", QA: "+974", RE: "+262", RO: "+40", RS: "+381",
  RW: "+250", SA: "+966", SC: "+248", SE: "+46", SG: "+65", SI: "+386", SK: "+421", SM: "+378",
  SN: "+221", SR: "+597", ST: "+239", SV: "+503", SX: "+1721", SZ: "+268", TC: "+1649", TD: "+235",
  TG: "+228", TH: "+66", TL: "+670", TN: "+216", TO: "+676", TR: "+90", TT: "+1868", TV: "+688",
  TW: "+886", TZ: "+255", UA: "+380", UG: "+256", US: "+1", UY: "+598", UZ: "+998", VA: "+39",
  VC: "+1784", VG: "+1284", VI: "+1340", VN: "+84", VU: "+678", WF: "+681", WS: "+685", ZA: "+27",
  ZM: "+260",
};

const flagOf = (code) => code.replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export const dialOf = (code) => DIAL[code] || "";

export const countries = (locale = "en") => {
  let names;
  try {
    names = new Intl.DisplayNames([locale], { type: "region" });
  } catch {
    names = null;
  }
  return ALL.filter((c) => !BLOCKED.includes(c))
    .map((code) => ({ code, flag: flagOf(code), dial: DIAL[code] || "", name: names?.of(code) || code }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
};

export const MOROCCO = { code: "MA", flag: flagOf("MA"), dial: "+212", name: "Morocco" };
export const localeFlag = { en: flagOf("GB"), fr: flagOf("FR"), es: flagOf("ES"), it: flagOf("IT"), nl: flagOf("NL"), de: flagOf("DE"), ar: flagOf("MA") };
export default countries;
